import { gql } from "@urql/core";

export const supportInquiryTypeEnum = `
  enum SupportInquiryType {
    FEEDBACK
    BUG
  }
`;

export const supportInquiryInputType = `
  input SupportInquiry {
    from: String
    subject: String
    type: SupportInquiryType!
    message: String!
    attachments: [Upload!]
  }
`;

export const supportInquiryMutation = `
  extend type Mutation {
    supportInquiry(input: SupportInquiry!): Boolean!
  }
`;

export const SUPPORT_INQUIRY_MUTATION = gql`
  mutation SupportInquiry($input: SupportInquiry!) {
    supportInquiry(input: $input)
  }
`;
